namespace TabAurous.OMS {
    export interface DiscountingPolicyDetailsRow {
        DiscountDetailId?: number;
        DiscountId?: number;
        DiscountType?: Common.DiscountType;
        ProductTypeId?: number;
        ProductTypeCode?: string;
        CategoryId?: number;
        CategoryCode?: string;
        SubCategoryId?: number;
        SubCategoryCode?: string;
        ProcessId?: number;
        ProcessName?: string;
        Priority?: number;
        MaxDiscountPercent?: number;
    }

    export namespace DiscountingPolicyDetailsRow {
        export const idProperty = 'DiscountDetailId';
        export const localTextPrefix = 'OMS.DiscountingPolicyDetails';
        export const deletePermission = 'Masters:DiscountingPolicy:Delete';
        export const insertPermission = 'Masters:DiscountingPolicy:Add';
        export const readPermission = 'Masters:DiscountingPolicy:View';
        export const updatePermission = 'Masters:DiscountingPolicy:Edit';

        export declare const enum Fields {
            DiscountDetailId = "DiscountDetailId",
            DiscountId = "DiscountId",
            DiscountType = "DiscountType",
            ProductTypeId = "ProductTypeId",
            ProductTypeCode = "ProductTypeCode",
            CategoryId = "CategoryId",
            CategoryCode = "CategoryCode",
            SubCategoryId = "SubCategoryId",
            SubCategoryCode = "SubCategoryCode",
            ProcessId = "ProcessId",
            ProcessName = "ProcessName",
            Priority = "Priority",
            MaxDiscountPercent = "MaxDiscountPercent"
        }
    }
}
